import { routerStyxie } from '@/router/styxieBridge'

// Audit reports is client-side routed: every action boots the shared router
// shell. No styxie payload — the index fetches its filter options through
// GET /api/audit_report_configurations/index_for_select and the show page
// fetches the GET /api/audit_reports/:id envelope in route `prepare`.
Styxie.Initializers.AuditReports = routerStyxie({ actions: ['index', 'show']})
